import {useEffect, useState} from 'react';
import FadeLoader from 'react-spinners/FadeLoader';

/* -------------------- Constants -------------------- */
const FALLBACK_COLOR = 'rgb(220, 80, 160)';

/* -------------------- Utilities -------------------- */
const resolveAccentColor = (): string => {
    if (typeof window === 'undefined') {
        return FALLBACK_COLOR;
    }

    const accentColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--accent-primary')
        .trim();

    return accentColor ? `rgb(${accentColor})` : FALLBACK_COLOR;
};

/* -------------------- Loading Spinner -------------------- */
const LoadingSpinner = () => {
    const [color, setColor] = useState(resolveAccentColor);

    useEffect(() => {
        const updateColor = () => setColor(resolveAccentColor());

        updateColor();

        const observer = new MutationObserver(updateColor);

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div className='min-h-[40vh] flex items-center justify-center'>
            <FadeLoader
                color={color}
                height={25}
                width={5}
                radius={2}
                margin={-7}
                speedMultiplier={1}
                aria-label='Loading'
            />
            <span className='sr-only'>Loading…</span>
        </div>
    );
};

export default LoadingSpinner;
